import useTableRestQuery from "@/directory/hooks/useTableRestQuery";
import { API_BASE_URL } from "@/api/api.config";

const DEFAULT_SORT_BY = [{ id: "last_name", desc: false }];

const useTeacherStudentGetList = (
  teacherId,
  pageSize,
  defaultSortBy = DEFAULT_SORT_BY,
) => {
  return useTableRestQuery(
    `${API_BASE_URL}/api/v3/teacher/${teacherId}/student/`,
    pageSize,
    defaultSortBy,
  );
};

export default useTeacherStudentGetList;
